/* ============================================
   Folk Objects - Trade Account Registration
   Vanilla JS – Shopify-compatible
   ============================================ */

(function () {
  'use strict';

  const RETURN_URL_KEY = 'folk_return_url';
  function getReturnUrl() {
    try { return localStorage.getItem(RETURN_URL_KEY) || '/pages/account'; } catch (e) { return '/pages/account'; }
  }
  function clearReturnUrl() {
    try { localStorage.removeItem(RETURN_URL_KEY); } catch (e) {}
  }

  // ---- State ----
  const formData = {
    firstName: '',
    lastName: '',
    email: '',
    country: 'India',
    phoneCode: '+91',
    phone: '',
    businessNature: '',
    businessType: '',
    website: '',
    gstNumber: ''
  };

  let resendTimer = null;
  let isSubmitting = false;
  let isVerifying = false;

  // ---- DOM helpers ----
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  // ---- Country data (code + dial) ----
  const countries = [
    { name: 'India', code: '+91' },
    { name: 'United States', code: '+1' },
    { name: 'United Kingdom', code: '+44' },
    { name: 'Australia', code: '+61' },
    { name: 'Canada', code: '+1' },
    { name: 'Germany', code: '+49' },
    { name: 'France', code: '+33' },
    { name: 'Japan', code: '+81' },
    { name: 'Singapore', code: '+65' },
    { name: 'UAE', code: '+971' },
    { name: 'Saudi Arabia', code: '+966' },
    { name: 'South Africa', code: '+27' },
    { name: 'Brazil', code: '+55' },
    { name: 'Mexico', code: '+52' },
    { name: 'Netherlands', code: '+31' },
    { name: 'Italy', code: '+39' },
    { name: 'Spain', code: '+34' },
    { name: 'China', code: '+86' },
    { name: 'South Korea', code: '+82' },
    { name: 'New Zealand', code: '+64' }
  ];

  // ---- Initialize ----
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    setupAccordion();
    setupGetStarted();
    populateCountrySelect();
    setupCustomSelect();
    setupNavigation();
    setupFormValidation();
    setupOtpInputs();
    setupGstButtonGuard();
    showScreen('landing');
  }

  // Disable "Next" on step 2 when GST is filled but doesn't match the GSTIN format.
  // Empty GST stays enabled so the click handler can surface the standard required-field error.
  function setupGstButtonGuard() {
    var gstInput = $('#folk-gst');
    var nextBtn = $('#folk-next-step2');
    if (!gstInput || !nextBtn) return;

    var GST_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

    function update() {
      var val = gstInput.value.trim();
      if (val.length === 0) {
        nextBtn.disabled = false;
        return;
      }
      var stripped = val.replace(/\s/g, '').toUpperCase();
      nextBtn.disabled = !GST_REGEX.test(stripped);
    }

    gstInput.addEventListener('input', update);
    gstInput.addEventListener('blur', update);
    update();
  }

  // ---- Screen management ----
  function showScreen(name) {
    $$('.folk-screen').forEach(s => s.classList.remove('active'));
    const el = $(`#folk-${name}`);
    if (el) {
      el.classList.remove('active');
      void el.offsetWidth;
      el.classList.add('active');
    }
    updateStepDots(name);
    const app = $('.folk-trade-app');
    if (app) app.scrollTop = 0;
    // Auto-scroll to the section — controlled by the "Auto-scroll to this section"
    // section setting. Default true to preserve existing behavior.
    var shouldScroll = !app || app.getAttribute('data-folk-auto-scroll') !== 'false';
    if (shouldScroll) {
      window.scrollTo({ top: app ? app.offsetTop : 0, behavior: 'smooth' });
    }
  }

  function updateStepDots(screen) {
    const mapping = { step1: 0, step2: 1, step3: 2 };
    const stepIndex = mapping[screen];
    if (stepIndex === undefined) return;
    $$('.folk-steps').forEach(container => {
      $$(`.folk-step-dot`, container).forEach((dot, i) => {
        dot.classList.remove('active', 'completed');
        if (i === stepIndex) dot.classList.add('active');
        else if (i < stepIndex) dot.classList.add('completed');
      });
    });
  }

  // ---- Accordion ----
  function setupAccordion() {
    $$('.folk-accordion-header').forEach(btn => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.folk-accordion-item');
        const wasOpen = item.classList.contains('open');
        $$('.folk-accordion-item').forEach(i => i.classList.remove('open'));
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  // ---- Get Started ----
  function setupGetStarted() {
    const btn = $('#folk-get-started');
    if (btn) btn.addEventListener('click', () => showScreen('step1'));
  }

  // ---- Country select ----
  function populateCountrySelect() {
    const sel = $('#folk-country');
    if (!sel) return;
    sel.innerHTML = '';
    countries.forEach(c => {
      const opt = document.createElement('option');
      opt.value = c.name;
      opt.textContent = c.name;
      sel.appendChild(opt);
    });
    sel.value = 'India';
    sel.addEventListener('change', () => {
      const match = countries.find(c => c.name === sel.value);
      if (match) {
        formData.country = match.name;
        formData.phoneCode = match.code;
        const codeInput = $('#folk-phone-code');
        if (codeInput) codeInput.value = match.code;
      }
    });
  }

  // ---- Custom select (business type) ----
  function setupCustomSelect() {
    $$('.folk-custom-select').forEach(wrapper => {
      const trigger = $('.folk-custom-select-trigger', wrapper);
      const options = $$('.folk-custom-select-option', wrapper);
      const hiddenInput = wrapper.dataset.target ? $(`#${wrapper.dataset.target}`) : null;

      trigger.setAttribute('tabindex', '0');

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        $$('.folk-custom-select').forEach(w => {
          if (w !== wrapper) w.classList.remove('open');
        });
        wrapper.classList.toggle('open');
      });

      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });

      options.forEach(opt => {
        opt.addEventListener('click', () => {
          const val = opt.dataset.value;
          const label = opt.textContent;
          const triggerText = $('.folk-custom-select-text', trigger);
          if (triggerText) triggerText.textContent = label;
          trigger.classList.add('has-value');
          options.forEach(o => o.classList.remove('selected'));
          opt.classList.add('selected');
          wrapper.classList.remove('open');
          if (hiddenInput) {
            hiddenInput.value = val;
            hiddenInput.dispatchEvent(new Event('input'));
          }
          formData.businessType = val;
        });
      });
    });

    document.addEventListener('click', () => {
      $$('.folk-custom-select').forEach(w => w.classList.remove('open'));
    });
  }

  // ---- Navigation ----
  function setupNavigation() {
    const nextStep1 = $('#folk-next-step1');
    if (nextStep1) nextStep1.addEventListener('click', async () => {
      if (!validateStep1()) return;
      collectStep1();

      // Check if email already registered
      const emailInput = $('#folk-email');
      const originalText = nextStep1.textContent;
      nextStep1.disabled = true;
      nextStep1.textContent = 'Checking...';
      try {
        const { exists } = await FolkAPI.checkEmail(formData.email);
        if (exists) {
          showAccountExistsPopup();
          return;
        }
        showScreen('step2');
      } catch (err) {
        showFieldError(emailInput, err.message || 'Could not verify email. Please try again.');
      } finally {
        nextStep1.disabled = false;
        nextStep1.textContent = originalText;
      }
    });

    const nextStep2 = $('#folk-next-step2');
    if (nextStep2) nextStep2.addEventListener('click', () => {
      if (validateStep2()) {
        collectStep2();
        populateVerify();
        showScreen('step3');
      }
    });

    const backStep2 = $('#folk-back-step2');
    if (backStep2) backStep2.addEventListener('click', () => showScreen('step1'));

    const backStep3 = $('#folk-back-step3');
    if (backStep3) backStep3.addEventListener('click', () => showScreen('step2'));

    // Submit → send signup request → OTP screen
    const submitBtn = $('#folk-submit');
    if (submitBtn) submitBtn.addEventListener('click', submitSignup);

    // Verify OTP → Success
    const verifyBtn = $('#folk-verify-otp');
    if (verifyBtn) verifyBtn.addEventListener('click', () => {
      verifyOtp();
    });

    // Resend OTP
    const resendBtn = $('#folk-resend-btn');
    if (resendBtn) resendBtn.addEventListener('click', () => {
      resendOtp();
    });
  }

  // ---- Collect form data ----
  function collectStep1() {
    formData.firstName = ($('#folk-firstname') || {}).value || '';
    formData.lastName = ($('#folk-lastname') || {}).value || '';
    formData.email = ($('#folk-email') || {}).value || '';
    formData.country = ($('#folk-country') || {}).value || '';
    formData.phoneCode = ($('#folk-phone-code') || {}).value || '';
    formData.phone = ($('#folk-phone') || {}).value || '';
  }

  function collectStep2() {
    formData.businessNature = ($('#folk-business-nature') || {}).value || '';
    formData.website = ($('#folk-website') || {}).value || '';
    formData.gstNumber = ($('#folk-gst') || {}).value || '';
  }

  // ---- Populate verify screen ----
  function populateVerify() {
    const set = (id, val) => {
      const el = $(`#${id}`);
      if (el) el.textContent = (val && val.trim()) ? val.trim() : '-';
    };
    const fullName = `${formData.firstName} ${formData.lastName}`.trim();
    set('verify-name', fullName);
    set('verify-email', formData.email);
    set('verify-country', formData.country);
    set('verify-phone', `${formData.phoneCode} ${formData.phone}`);
    set('verify-business-nature', formData.businessNature);
    set('verify-business-type', formData.businessType);
    set('verify-website', formData.website);
    set('verify-gst', formData.gstNumber);
  }

  // ============================================
  // OTP LOGIC
  // ============================================

  function setupOtpInputs() {
    const boxes = $$('.folk-otp-box');
    boxes.forEach((box, i) => {
      // Only allow digits
      box.addEventListener('input', (e) => {
        const val = box.value.replace(/[^0-9]/g, '');
        box.value = val;

        // Clear error state on new input
        boxes.forEach(b => b.classList.remove('error'));
        const errEl = $('#folk-otp-error');
        if (errEl) errEl.classList.add('folk-hidden');

        if (val && i < boxes.length - 1) {
          boxes[i + 1].focus();
        }

        // Mark filled
        box.classList.toggle('filled', val.length > 0);
      });

      // Handle backspace to go to previous box
      box.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && !box.value && i > 0) {
          boxes[i - 1].focus();
          boxes[i - 1].value = '';
          boxes[i - 1].classList.remove('filled');
        }
        // Enter to submit
        if (e.key === 'Enter') {
          verifyOtp();
        }
      });

      // Handle paste – spread digits across all boxes
      box.addEventListener('paste', (e) => {
        e.preventDefault();
        const pasted = (e.clipboardData.getData('text') || '').replace(/[^0-9]/g, '');
        for (let j = 0; j < boxes.length; j++) {
          boxes[j].value = pasted[j] || '';
          boxes[j].classList.toggle('filled', !!pasted[j]);
        }
        // Focus last filled or the next empty
        const focusIdx = Math.min(pasted.length, boxes.length - 1);
        boxes[focusIdx].focus();
      });
    });
  }

  function showOtpScreen() {
    // Show user's email on the OTP page
    const emailDisplay = $('#folk-otp-email-display');
    if (emailDisplay) emailDisplay.textContent = formData.email;

    // Clear previous OTP input
    $$('.folk-otp-box').forEach(b => {
      b.value = '';
      b.classList.remove('filled', 'error');
    });
    const errEl = $('#folk-otp-error');
    if (errEl) errEl.classList.add('folk-hidden');

    showScreen('otp');
    startResendTimer();

    // Auto-focus first box
    const firstBox = $('.folk-otp-box');
    if (firstBox) setTimeout(() => firstBox.focus(), 350);
  }

  function getEnteredOtp() {
    return $$('.folk-otp-box').map(b => b.value).join('');
  }

  async function submitSignup() {
    if (isSubmitting) return;
    const btn = $('#folk-submit');
    const originalText = btn ? btn.textContent : '';
    isSubmitting = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Submitting...'; }
    try {
      await FolkAPI.signup({
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        country: formData.country,
        phoneCode: formData.phoneCode,
        phone: formData.phone,
        businessNature: formData.businessNature,
        businessType: formData.businessType,
        website: formData.website,
        gstNumber: formData.gstNumber,
      });
      showOtpScreen();
    } catch (err) {
      if (err.status === 409) {
        showAccountExistsPopup();
      } else {
        alert(err.message || 'Could not submit. Please try again.');
      }
    } finally {
      isSubmitting = false;
      if (btn) { btn.disabled = false; btn.textContent = originalText || 'Submit'; }
    }
  }

  async function verifyOtp() {
    if (isVerifying) return;
    const entered = getEnteredOtp();
    const boxes = $$('.folk-otp-box');
    const errEl = $('#folk-otp-error');

    if (entered.length < 4) {
      boxes.forEach(b => { if (!b.value) b.classList.add('error'); });
      return;
    }

    isVerifying = true;
    const btn = $('#folk-verify-otp');
    const originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Verifying...'; }

    try {
      const data = await FolkAPI.verify(formData.email, entered, 'signup');
      FolkAPI.setToken(data.token);
      FolkAPI.setUser(data.user);
      if (resendTimer) clearInterval(resendTimer);
      showScreen('success');
      var dest = getReturnUrl(); clearReturnUrl();
      setTimeout(() => { window.location.href = dest; }, 1800);
    } catch (err) {
      boxes.forEach(b => { b.classList.add('error'); b.classList.remove('filled'); });
      if (errEl) {
        errEl.textContent = err.message || 'Invalid code. Please try again.';
        errEl.classList.remove('folk-hidden');
      }
    } finally {
      isVerifying = false;
      if (btn) { btn.disabled = false; btn.textContent = originalText || 'Verify'; }
    }
  }

  function startResendTimer() {
    if (resendTimer) clearInterval(resendTimer);

    let seconds = 30;
    const btn = $('#folk-resend-btn');
    const timerSpan = $('#folk-resend-timer');
    if (!btn || !timerSpan) return;

    btn.disabled = true;
    timerSpan.textContent = `(${seconds}s)`;

    resendTimer = setInterval(() => {
      seconds--;
      timerSpan.textContent = `(${seconds}s)`;

      if (seconds <= 0) {
        clearInterval(resendTimer);
        resendTimer = null;
        btn.disabled = false;
        timerSpan.textContent = '';
      }
    }, 1000);
  }

  async function resendOtp() {
    $$('.folk-otp-box').forEach(b => {
      b.value = '';
      b.classList.remove('filled', 'error');
    });
    const errEl = $('#folk-otp-error');
    if (errEl) errEl.classList.add('folk-hidden');

    try {
      // Re-issue a signup OTP by re-submitting the signup payload
      await FolkAPI.signup({
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        country: formData.country,
        phoneCode: formData.phoneCode,
        phone: formData.phone,
        businessNature: formData.businessNature,
        businessType: formData.businessType,
        website: formData.website,
        gstNumber: formData.gstNumber,
      });
      startResendTimer();
      const firstBox = $('.folk-otp-box');
      if (firstBox) firstBox.focus();
    } catch (err) {
      if (errEl) {
        errEl.textContent = err.message || 'Could not resend code';
        errEl.classList.remove('folk-hidden');
      }
    }
  }

  // ---- Validation ----
  function setupFormValidation() {
    $$('.folk-input[data-validate]').forEach(input => {
      input.addEventListener('blur', () => {
        validateField(input);
      });
      input.addEventListener('input', () => {
        input.classList.remove('invalid');
        const hint = input.closest('.folk-form-group').querySelector('.folk-field-hint');
        if (hint) hint.textContent = '';
      });
    });
  }

  function validateField(input) {
    const type = input.dataset.validate;
    const val = input.value.trim();
    let valid = true;
    let msg = '';

    switch (type) {
      case 'required':
        valid = val.length > 0;
        msg = 'This field is required';
        break;
      case 'email':
        valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
        msg = 'Please enter a valid email';
        break;
      case 'phone': {
        var phoneDigits = val.replace(/\D/g, '');
        valid = /^[6-9]\d{9}$/.test(phoneDigits);
        msg = val.length === 0 ? 'This field is required' : 'Enter a valid 10-digit mobile number';
        break;
      }
      case 'gst': {
        var gstStripped = val.replace(/\s/g, '').toUpperCase();
        valid = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(gstStripped);
        msg = val.length === 0 ? 'This field is required' : 'Enter a valid 15-character GSTIN';
        break;
      }
      case 'url':
        valid = val === '' || /^[\w.-]+\.[a-z]{2,}$/i.test(val) || /^https?:\/\//i.test(val);
        msg = 'Please enter a valid website';
        break;
      case 'website_or_instagram':
        valid = val === ''
          || /^[\w.-]+\.[a-z]{2,}$/i.test(val)
          || /^https?:\/\//i.test(val)
          || /^@?[a-zA-Z0-9_.]{1,30}$/.test(val)
          || /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/i.test(val);
        msg = 'Enter a website (folkobjects.com) or Instagram handle (@folkobjects)';
        break;
    }

    showValidIcon(input, valid && val.length > 0);

    if (!valid && val.length > 0) {
      input.classList.add('invalid');
      input.classList.remove('valid');
      const hint = input.closest('.folk-form-group').querySelector('.folk-field-hint');
      if (hint) hint.textContent = msg;
    } else if (valid && val.length > 0) {
      input.classList.remove('invalid');
      input.classList.add('valid');
      const hint = input.closest('.folk-form-group').querySelector('.folk-field-hint');
      if (hint) hint.textContent = '';
    }

    return valid && val.length > 0;
  }

  function showFieldError(input, msg) {
    if (!input) return;
    input.classList.add('invalid');
    input.classList.remove('valid');
    const group = input.closest('.folk-form-group');
    if (group) {
      const hint = group.querySelector('.folk-field-hint');
      if (hint) hint.textContent = msg;
    }
    showValidIcon(input, false);
  }

  function showValidIcon(input, isValid) {
    const wrap = input.closest('.folk-input-wrap');
    if (!wrap) return;
    let icon = wrap.querySelector('.folk-input-icon');
    if (!icon) {
      icon = document.createElement('span');
      icon.className = 'folk-input-icon';
      wrap.appendChild(icon);
    }
    const val = input.value.trim();
    if (val.length === 0) {
      icon.textContent = '';
      icon.className = 'folk-input-icon';
      return;
    }
    icon.textContent = isValid ? '✓' : '✗';
    icon.className = `folk-input-icon ${isValid ? 'valid' : 'invalid'}`;
  }

  function validateStep1() {
    const fields = ['#folk-firstname', '#folk-lastname', '#folk-email', '#folk-phone'];
    let allValid = true;
    fields.forEach(sel => {
      const input = $(sel);
      if (input) {
        const ok = validateField(input);
        if (!ok) allValid = false;
      }
    });
    return allValid;
  }

  function validateStep2() {
    let allValid = true;
    const nature = $('#folk-business-nature');
    if (nature) {
      const ok = validateField(nature);
      if (!ok) allValid = false;
    }
    if (!formData.businessType) {
      const wrapper = $('.folk-custom-select');
      if (wrapper) {
        const trigger = $('.folk-custom-select-trigger', wrapper);
        if (trigger) trigger.style.borderColor = 'var(--folk-error)';
      }
      allValid = false;
    }
    const gst = $('#folk-gst');
    if (gst) {
      const ok = validateField(gst);
      if (!ok) allValid = false;
    }
    return allValid;
  }

  function showAccountExistsPopup() {
    if ($('#folk-account-exists-modal')) return;
    const overlay = document.createElement('div');
    overlay.id = 'folk-account-exists-modal';
    overlay.innerHTML = `
      <style>
        #folk-account-exists-modal {
          position: fixed; inset: 0; background: rgba(0,0,0,.5);
          display: flex; align-items: center; justify-content: center;
          z-index: 9999; animation: folkFadeIn .15s ease;
        }
        #folk-account-exists-modal .folk-modal-box {
          background: #fff; border-radius: 12px; padding: 32px;
          max-width: 400px; width: 90%; text-align: center;
          box-shadow: 0 20px 60px rgba(0,0,0,.2);
          font-family: inherit;
        }
        #folk-account-exists-modal h3 { margin: 0 0 8px; font-size: 18px; font-weight: 600; }
        #folk-account-exists-modal p { margin: 0 0 24px; color: #666; font-size: 14px; line-height: 1.5; }
        #folk-account-exists-modal .folk-modal-actions { display: flex; gap: 12px; justify-content: center; }
        #folk-account-exists-modal button, #folk-account-exists-modal a {
          padding: 12px 22px; border-radius: 8px; font-size: 14px;
          font-weight: 500; cursor: pointer; border: 1px solid #ddd;
          text-decoration: none; display: inline-block; text-align: center;
          min-width: 120px;
        }
        #folk-account-exists-modal button { background: #fff; color: #1a1a1a; }
        #folk-account-exists-modal a {
          background: var(--folk-primary-hover, #5a3023); color: #fff; border-color: var(--folk-primary-hover, #5a3023);
        }
        @keyframes folkFadeIn { from { opacity: 0 } to { opacity: 1 } }
      </style>
      <div class="folk-modal-box" role="dialog" aria-modal="true">
        <h3>Account already exists</h3>
        <p>An account with this email already exists. Please log in instead.</p>
        <div class="folk-modal-actions">
          <button type="button" data-action="cancel">Use Different Email</button>
          <a href="/pages/trade-login" data-action="login">Log In</a>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    const close = () => overlay.remove();
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
      if (e.target.dataset.action === 'cancel') close();
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });
  }

})();
